var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { CatalogConnectV2Client } from '@square/dashboard-items-data/clients/catalog-connect-v2';
import CatalogObjectAdapter from '@square/dashboard-items-data/adapters/connect/catalog-object';
import { inject as service } from '@ember/service';
import { getItemsCategories } from '@square/dashboard-items-data/utils/category';
import { getModifierListsForItems } from '@square/dashboard-items-data/utils/modifiers';

// eslint-disable-next-line ember/use-ember-data-rfc-395-imports

import { X_CATALOG_API_SUPPORTED_FEATURES_BUYER_FACING_NAME, X_CATALOG_API_SUPPORTED_FEATURES_CHANNEL_INTEGRATIONS, X_CATALOG_API_SUPPORTED_FEATURES_COMBOS, X_CATALOG_API_SUPPORTED_FEATURES_HEADER_NAME, X_CATALOG_API_SUPPORTED_FEATURES_PROGRAM_ELIGIBILITY } from '@square/dashboard-items-data/utils/api-constants';
const DEFAULT_SEARCH_CATALOG_ITEMS_API_VERSION = '2051-01-04';
export let NullFieldFilters = /*#__PURE__*/function (NullFieldFilters) {
  NullFieldFilters["CATEGORY_ID"] = "CATEGORY_ID";
  NullFieldFilters["VENDOR_ID"] = "VENDOR_ID";
  NullFieldFilters["SKU"] = "SKU";
  NullFieldFilters["REGULAR_CATEGORY_ID"] = "REGULAR_CATEGORY_ID";
  return NullFieldFilters;
}({});
export let StockLevel = /*#__PURE__*/function (StockLevel) {
  StockLevel["LOW"] = "LOW";
  StockLevel["OUT"] = "OUT";
  return StockLevel;
}({});
let Item = (_class = class Item extends CatalogObjectAdapter {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "features", _descriptor, this);
    _initializerDefineProperty(this, "catalogFeatures", _descriptor2, this);
    // userSubscriptions is defined in the @dashboard namespace, so we can't import it here
    _initializerDefineProperty(this, "userSubscriptions", _descriptor3, this);
  }
  get isComboItemsEnabled() {
    return (this.features.isEnabled('catalog/combos_r0') || this.features.isEnabled('catalog/release-combos-beta-2025')) && this.userSubscriptions.isSubscribedToCombos;
  }
  get isBuyerFacingNameEnabled() {
    return this.features.isEnabled('catalog/enable-buyer-facing-name');
  }
  get isProgramEligibilityEnabled() {
    return this.features.isEnabled('catalog/program-eligibility-attribute');
  }
  get isChannelIntegrationsEnabled() {
    return this.features.isEnabled('catalog/use_channel_integrations');
  }
  get headers() {
    const supportedFeatures = [X_CATALOG_API_SUPPORTED_FEATURES_COMBOS];
    if (this.isBuyerFacingNameEnabled) {
      supportedFeatures.push(X_CATALOG_API_SUPPORTED_FEATURES_BUYER_FACING_NAME);
    }
    if (this.isProgramEligibilityEnabled) {
      supportedFeatures.push(X_CATALOG_API_SUPPORTED_FEATURES_PROGRAM_ELIGIBILITY);
    }
    if (this.isChannelIntegrationsEnabled) {
      supportedFeatures.push(X_CATALOG_API_SUPPORTED_FEATURES_CHANNEL_INTEGRATIONS);
    }
    return {
      'Square-Version': DEFAULT_SEARCH_CATALOG_ITEMS_API_VERSION,
      [X_CATALOG_API_SUPPORTED_FEATURES_HEADER_NAME]: supportedFeatures.join(',')
    };
  }

  // @ts-expect-error TS doesn't like that we return a promise (due to async) and not an RSVP.Promise here.
  async query(store, type, params, recordArray) {
    const {
      useSearchCatalogObjects = false,
      includeCategories,
      includeModifierLists,
      ...query
    } = params;
    let fetchedItems = [];
    if (useSearchCatalogObjects) {
      fetchedItems = await super.query(store, type, query, recordArray);
    } else {
      const {
        items = [],
        cursor
      } = await CatalogConnectV2Client.searchCatalogItems(query, {
        headers: params.headers ?? this.headers
      });
      items.meta = {
        cursor
      };
      fetchedItems = items;
    }
    if (fetchedItems.length === 0) {
      return fetchedItems;
    }
    const relatedObjectsPromises = [];
    if (includeModifierLists) {
      const modifierLists = getModifierListsForItems(this.store, fetchedItems);
      relatedObjectsPromises.push(modifierLists);
    }
    if (includeCategories) {
      const categories = getItemsCategories(store, fetchedItems);
      relatedObjectsPromises.push(categories);
    }

    // attach related objects promises to first item so they're loaded into the store
    fetchedItems[0].relatedObjects = Promise.all(relatedObjectsPromises);
    return fetchedItems;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "catalogFeatures", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "userSubscriptions", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Item as default };